
import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams, useRouteMatch, useLocation, useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Button, Col, Container, Row, Image, InputGroup, Form } from "react-bootstrap";
import { Card } from "primereact/card";
import "./NewPassword.scss";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faKeySkeleton } from "@fortawesome/pro-solid-svg-icons";
import { Toast } from 'primereact/toast';
import { MainApi } from "../../../../../services/authentication/api";
import { Configuration } from "../../../../../services/authentication/configuration";
import JSEncrypt from "jsencrypt";
import AuthContext from "../../../context";



const MetKey = `-----BEGIN PUBLIC KEY-----
MIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQB3prLK5rWvXhOfC8JyMImg
NWH1XaY8+pQGs5FVy0dAPcogNi7FJKQvjNOx2nNl4ESU1ShT3TNe69L8x45MR2zg
OGbgN1NXdCCYu7bsJlQUxWuu1jEqZVl5PKgz8JSrkk47kRUFHw2Ogb50nYhR9X0q
LaU+UZshu5UG/ut/gaSS8TStrHwGifYsVRJIytSldEWlUWtuh19dc7RHVhwd3nd5
lBqqJC3cy2va2rRjC0f/UwHCANfvOPMT1Kfe+9ygihQ8l9B199+kgzy1Z/loBRsr
mVttnyKF9qvjzXbk5ZaFznyAFOu0pdLf3Wqp0X7YPFV7K2tqBoLJACUpH2NSUDej
AgMBAAE=
-----END PUBLIC KEY-----`;

const NewPassword = (props) => { //  email, fingerPrint
    const mainApi = new MainApi(new Configuration({ basePath: process.env.REACT_APP_AUTHENTICATION_API_BASE_PATH }));

    const contextVal = useContext(AuthContext);
    const [password, setPassword] = useState("");
    const [passwordAgain, setPasswordAgain] = useState("");
    const [isShowPassword, setIsShowPassword] = useState(false);
    const [isShowPasswordAgain, setIsShowPasswordAgain] = useState(false);
    const [fingerPrint, setFingerPrint] = useState("");
    const toast = useRef(null);
    const navigate = useNavigate();
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(MetKey);



    const beginLogin = () => {
        try {
            contextVal.setAuthState({
                ...contextVal?.authState,
                loginView: true,
                verificationView: false,
                passwordResetView: false,
            });

        } catch (error) {
            // console.log("verificationHandle: " + error);
        }
    };


    const handleMouseDownPassword = () => {
        setIsShowPassword(true);
    };

    const handleMouseUpPassword = () => {
        setIsShowPassword(false);
    };

    const handleMouseDownPasswordAgain = () => {
        setIsShowPasswordAgain(true);
    }

    const handleMouseUpPasswordAgain = () => {
        setIsShowPasswordAgain(false);
    }

    const resetPassword = () => {

        const currentPath = window.location.search;

        if (!password || !passwordAgain) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Şifre alanları boş olamaz.', life: 3000 });
            return;
        }

        if (password !== passwordAgain) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Şifreler uyuşmuyor.', life: 3000 });
            return;
        }

        if (!password || !passwordAgain) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Şifre alanları boş olamaz.', life: 3000 });
            return;
        }

        if (password.length < 6 || passwordAgain.length < 6) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Şifre en az 6 karakter olmalıdır.', life: 3000 });
            return;
        }

        if (password !== passwordAgain) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Şifreler uyuşmuyor.', life: 3000 });
            return;
        }
        

        const encryptPassword = encrypt.encrypt(password);
        mainApi.apiMainResetPasswordSmsGet(encryptPassword, props.fingerPrint).then((res) => {
            
            if (res.data.Status == "Ok") {
                toast.current.show({ severity: 'success', summary: 'Şifreniz başarıyla sıfırlandı', detail: 'Giriş ekranına yönlendiriliyorsunuz...', life: 3000 });
                setTimeout(() => {
                    contextVal.setAuthState({
                        ...contextVal?.authState,
                        loginView: true,
                        verificationView: false,
                        passwordResetView: false,
                    });
                }, 500);
                return;
            }
            else if (res.data.Status == "Error") {
                if (res.data.Error.includes("0x2393B2")) {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Zaman aşımına uğradınız lütfen tekrar deneyiniz.', life: 3000 });
                    // setTimeout(() => {
                    //     contextVal.setAuthState({
                    //         ...contextVal?.authState,
                    //         loginView: true,
                    //         verificationView: false,
                    //         passwordResetView: false,
                    //     });
                    // }, 500);
                    return;
                }
                else if (res.data.Error.includes("0x0C3541")) {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Böyle bir hesap bulunamadı.', life: 3000 });
                    return;
                }
                else if (res.data.Error.includes("0x3B636F")) {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Böyle bir mail hesabı bulunamadı.', life: 3000 });
                    return;
                }
                else if (res.data.Error.includes("0xD1D200")) {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Son şifrenizden farklı bir şifre belirleyiniz.', life: 3000 });
                    return;
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Şifre sıfırlanırken bir hata oluştu', life: 3000 });
                    return;
                }
            }
            else {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Şifre sıfırlanırken bir hata oluştu', life: 3000 });
                return;
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Şifre sıfırlanırken bir hata oluştu', life: 3000 });
        });
    }




    return (
        <>
            <Toast ref={toast} position="bottom-right" />
            <div className="password-new-reset-page">
                <Toast ref={toast} position="bottom-right" />

                <Container className="password-reset-container">

                    <Row>

                        <Col md="12">
                            <div className="col-md-12 roboto-bold-34 color-text m-t-15">Şifrenizi Sıfırlayın</div>
                        </Col>

                    </Row>

                    <Row className="m-t-30">
                        <Col>

                            <InputGroup className="user-password-input-group w-100">
                                <InputGroup.Text id="inputGroup-sizing-default" className="p-5">
                                    <FontAwesomeIcon icon={faKeySkeleton} className="userLoginKeyIcon" />
                                </InputGroup.Text>
                                <Form.Control className="userLoginPassword customRegisterInput"
                                    value={password}
                                    onChange={(e) => { setPassword(e.target.value) }}
                                    type={isShowPassword ? "text" : "password"}
                                    aria-label="Default" aria-describedby="inputGroup-sizing-default" placeholder="Şifre" name="password" />
                                <InputGroup.Text id="inputGroup-sizing-default" className="userLoginEyeIcon"
                                    onMouseDown={handleMouseDownPassword}
                                    onMouseUp={handleMouseUpPassword}
                                    onMouseLeave={handleMouseUpPassword}
                                >
                                    <FontAwesomeIcon icon={isShowPassword ? faEye : faEyeSlash} />
                                </InputGroup.Text>
                            </InputGroup>

                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <InputGroup className="user-password-input-group w-100">
                                <InputGroup.Text id="inputGroup-sizing-default" className="p-5">
                                    <FontAwesomeIcon icon={faKeySkeleton} className="userLoginKeyIcon" />
                                </InputGroup.Text>
                                <Form.Control className="userLoginPassword customRegisterInput"
                                    value={passwordAgain}
                                    onChange={(e) => { setPasswordAgain(e.target.value) }}
                                    type={isShowPasswordAgain ? "text" : "password"}
                                    aria-label="Default" aria-describedby="inputGroup-sizing-default" placeholder="Şifre tekrar" name="password1" />
                                <InputGroup.Text id="inputGroup-sizing-default" className="userLoginEyeIcon"
                                    onMouseDown={handleMouseDownPasswordAgain}
                                    onMouseUp={handleMouseUpPasswordAgain}
                                    onMouseLeave={handleMouseUpPasswordAgain}
                                >
                                    <FontAwesomeIcon icon={isShowPasswordAgain ? faEye : faEyeSlash} />
                                </InputGroup.Text>
                            </InputGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Button className="reset-button m-t-10" onClick={resetPassword}>
                                Sıfırla
                            </Button>
                            <label className="color-text-grey roboto-medium-14 m-t-10 p-0" onClick={beginLogin}>
                                Şifrenizi hatırladınız mı? <span className="login-now-text">Giriş yap.</span>{" "}
                            </label>
                        </Col>
                    </Row>



                </Container>



            </div >
        </>

    )
}

export default NewPassword;